document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById("popup");
  var checkbox = document.getElementById("openPopupCheckbox");
  var span = document.getElementsByClassName("close")[0];
  var iframe = document.getElementById("frame_GmhxYU1iiVg-e9dRaM4ajA");

  // Abrir el popup al hacer clic en el checkbox
  checkbox.onclick = function() {
    if (checkbox.checked) {
      popup.style.display = "block";
      // Desactivar el botón de cerrar mientras no se envíe el formulario
      span.style.display = "none";
    }
  };

  // Evitar que el popup se cierre al hacer clic fuera de él
  window.onclick = function(event) {
    if (event.target == popup) {
      popup.style.display = "block";  // No cerrar
    }
  };

  // Monitorear el iframe para detectar cambios después del envío del formulario
  window.addEventListener('message', function(event) {
    console.log("Mensaje recibido desde el iframe:");
    console.log("Origen:", event.origin);
    console.log("Datos:", event.data);
    console.log("Test:", event);
    // Filtrar solo los mensajes del iframe (ajusta según sea necesario)
    if (event.origin === "https://formbuilder.hulkapps.com" && event.data.height < 300) {
      // Aquí podrías verificar el contenido del mensaje (event.data) para asegurarte de que es una respuesta del formulario.
      // Por ejemplo, podrías buscar alguna palabra clave que indique éxito.

      // Si el mensaje indica que el formulario fue enviado correctamente:
      popup.style.display = "none"; // Cerrar el popup
      
    }
  });

  // Desactivar el botón de cerrar manualmente
  span.style.display = "none";
});


// SCRIPT - CONFIRMAR CONTRASEÑA

document.addEventListener('DOMContentLoaded', function () {
    var password = document.getElementById('password');
    var confirmPassword = document.getElementById('confirm-password');
    var registerButton = document.getElementById('register-button');

    if (password && confirmPassword && registerButton) {
      function validatePasswords() {
        if (password.value !== confirmPassword.value) {
          confirmPassword.setCustomValidity("Las contraseñas no coinciden");
          return false;
        } else {
          confirmPassword.setCustomValidity("");
          return true;
        }
      }

      confirmPassword.addEventListener('input', validatePasswords);

      document.querySelector('form').addEventListener('submit', function(event) {
        if (!validatePasswords()) {
          event.preventDefault(); // Evita el envío del formulario si las contraseñas no coinciden
          alert("Las contraseñas no coinciden");
        }
      });
    } else {
      console.error("No se encontraron los elementos de contraseña o botón de registro.");
    }
  });
